import Poller from './Poller';
import {Api} from '../api';
import {mergeFileSettings} from './FileHelpers';

// uploadsPercentage & jobsPercentage should add to 100;
// having both variables is just a convenience

// we're saying uploads should take 50% of the progress bar
export const uploadsPercentage = 50;
// we're saying jobs should take 50% of the progress bar
export const jobsPercentage = 50;

// the number of files to put in a batch
export const batchSize = 10;

export default class Uploader {
  constructor(files, cover, projectId, updateStatus, updateDone, updateError, globalImageSettings) {
    this.files = files;
    this.cover = cover;
    this.projectId = projectId;
    this.updateStatus = updateStatus;
    this.updateDone = updateDone;
    this.updateError = updateError;
    this.globalImageSettings = globalImageSettings;
  }

  uploadFiles() {
    this.batches = this.constructFileBatches();
    this.uploadCount = this.batches.length;
    this.performUpload();
  }

  // physically upload file batches
  // the upload is a JS Promise; when each promise finishes its upload, it
  // calls the function again if there are still batches
  performUpload() {
    return Api.upload(`/api/projects/${this.projectId}/assets`, this.batches.shift()).then(json => {
      if (this.batches.length > 0) {
        let percent = this.calculateUploadPercentage(this.uploadCount - this.batches.length);
        this.updateStatus(percent);

        // provide a little buffer time
        setTimeout(() => { return this.performUpload()}, 300);
      } else {
        this.jobsTotal = json['jobs'] || 0;
        let percent = this.calculateUploadPercentage(this.uploadCount);
        this.updateStatus(percent);

        // finally, poll for jobs
        this.pollUploadedJobs();
      }
    }).catch( err => {
      this.updateError(err)
    });
  }

  pollUploadedJobs() {
    let poll = new Poller(
      () => {
        return Api.get(`/api/projects/${this.projectId}/status`);
      },

      (json) => {
        this.dispatchStatusUpdate(json);
        return json['status'] === 'ok';
      },

      () => {
        this.updateStatus(100);
        // make sure it has time to display the end of the progress bar
        setTimeout(this.updateDone, 200);
      },

      2000
    );

    poll.poll();
  }

  // calculate percentage from jobs remaining
  dispatchStatusUpdate(json) {
    let remaining = json['remaining'] || 0;
    let percent = this.calculateJobPercentage(remaining);
    this.updateStatus(percent);
  }

  // chunk settings, files into groups of batchSize
  constructFileBatches() {
    let batches = [];
    if(this.files.length <= batchSize) {
      let batch = this.formDataForBatch(this.files);
      batches.push(batch);
    } else {
      for(let i = 0; i < this.files.length; i += batchSize) {
        let filesChunk = this.files.slice(i, i+batchSize);
        let batch = this.formDataForBatch(filesChunk);
        batches.push(batch);
      }
    }
    return batches;
  }

  formDataForBatch(files) {
    let formData = new FormData();
    let settings = {};
    files.map(file => {
      // Add the file to the request.
      formData.append('assets[]', file, file.name);
      // add the dimensions to an object
      settings = mergeFileSettings(settings, file, this.globalImageSettings);
      if(file.name === this.cover) {
        settings['cover'] = file.name
      }
    });
    // needs cover handling
    formData.append('settings', JSON.stringify(settings));
    return formData;
  }

  // this calculates the percentage of finished jobs,
  // assuming the file uploads have completed
  calculateJobPercentage(remaining) {
    if(!remaining) {
      return 100;
    }
    let percent = 1 - (remaining / this.jobsTotal);
    return parseInt(percent * jobsPercentage) + uploadsPercentage;
  }

  calculateUploadPercentage(count) {
    return parseInt(count / this.uploadCount * uploadsPercentage);
  }
}
